import { render, staticRenderFns } from "./Follows.vue?vue&type=template&id=821f0d68&"
import script from "./Follows.vue?vue&type=script&lang=js&"
export * from "./Follows.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports